import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";

import Layout from "../../../../component/Layout/Layout";
import Card from "../../../../component/Layout/theme/card";
import PageChange from "../../../../component/pageChange";
import Marker from "./marker";
import MarkerLess from "./markerLess";

function IndexPage() {
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const params = useParams()
    const query = useLocation().search;
    const name = new URLSearchParams(query).get("name");



    useEffect(() => {
        document.title = "افزودن واقعیت افزوده به پروژه"
        if (!login) {
            window.location.href = '/auth'
        }
        if (params.type != "MARKER" && params.type != "MARKERLESS") {
            window.location.href = `/projects/edit/${params.id}`
        }
        setIsDataLoad(true)
    }, [])



    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (
                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        {params.type == "MARKER" ? <Marker type={params.type} name={name} id={params.id} /> : null}
                        {params.type == "MARKERLESS" ? <MarkerLess type={params.type} name={name} id={params.id} /> : null}
                    </div>
                ) : (
                    <PageChange />
                )}
            </Card>
        </>
    )
}

export default IndexPage